export default {
  creditCheckWrapperMargin: '0em',
  checkMarkTextFontSize: '0.8rem',
};
